import styled from "styled-components";
import { UIWidgetsDiv } from "../division/Division";

export const SelectWrapper = styled(UIWidgetsDiv)`
  width: 100%;
  height: 40px;
  position: relative;
  & > div:first-child {
    width: inherit;
    background: ${props => props.theme.brandWhite};
    border: none;
    text-align: left;
    height: inherit;
    border: 1px solid ${props => props.theme.borderLightGrey} !important;
    & > input {
      width: inherit;
      border: none;
      padding-left: ${props => props.theme.padding24};
      cursor: auto;
      background: ${props => (props.background ? props.background : "none")};
    }
    & > input:focus {
      outline: none;
    }
    & > img {
      position: absolute;
      background: white;
      width: 20px;
      height: 20px;
      top: 10px;
      right: 10px;
      pointer-events: none;
    }
  }
`;
